import RequestBuilder from "../RequestBuilder";
import {Method} from "../enum/Method";
import {PagedResponseJson} from "../json/PagedResponseJson";
import {TestRunJson} from "../json/TestRunJson"
import QualityCheckJson from "../json/QualityCheckJson"

export class TestRunRequests {
    static run(evalId: string, exampleId: number): Promise<TestRunJson> {
        return new RequestBuilder(Method.Post, `quality-checks/${evalId}/test-runs/${exampleId}`)
            .buildAndSend()
    }

    static list(evalId: string, page: number = 0, unscoredOnly = false): Promise<PagedResponseJson<TestRunJson>> {
        return new RequestBuilder(Method.Get, `quality-checks/${evalId}/test-runs?page=${page}&size=100&unscoredOnly=${unscoredOnly ? "true" : "false"}`)
            .buildAndSend()
    }

    static updateScore(evalId: string, exampleId: number, score: number): Promise<TestRunJson> {
        return new RequestBuilder(Method.Put, `quality-checks/${evalId}/test-runs/${exampleId}`)
            .withJson({score: score})
            .buildAndSend()
    }

    static delete(evalId: string, exampleId: number): Promise<QualityCheckJson> {
        return new RequestBuilder(Method.Delete, `quality-checks/${evalId}/test-runs/${exampleId}`)
            .buildAndSend()
    }

    static deleteAll(evalId: string): Promise<QualityCheckJson> {
        return new RequestBuilder(Method.Delete, `quality-checks/${evalId}/test-runs`)
            .buildAndSend()
    }
}